import AttachFileOutlined from '@mui/icons-material/AttachFileOutlined';
import { s } from '../../format/schema';
import { defineFieldType } from '../card';
import { AttachmentInput } from './FillInput';
import { AttachmentSettingsPanel } from './SettingsPanel';
import { attachedFile, attachmentSettings } from './schemas';

export const attachment = defineFieldType({
  type: 'attachment',
  name: 'Attachment',
  valueKind: 'files',
  settings: attachmentSettings,
  defaults: {},
  canResize: () => false,
  value: s.array(attachedFile),
  emptyValue: [],
  hasDefaultValue: false,
  validations: ['required', 'range'],
  operators: ['isFilled', 'isEmpty'],
  palette: [
    {
      name: 'Attachment',
      tooltip: 'Files the user attaches',
      group: 'Number, date and file',
      icon: AttachFileOutlined,
      validations: [{ kind: 'range', max: 1 }],
    },
  ],
  isEmpty: value => value.length === 0,
  quantity: value => value.length,
  fillLabel: () => 'legend',
  FillInput: AttachmentInput,
  settingsPanel: { at: 'settings', Panel: AttachmentSettingsPanel },
});
